import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from '../Modal'
import i18n from '../../../../i18n'
import womanWithGift from '../../../../svg/womanWithGift.svg'
import womanNotebook from '../../../../svg/womanNotebook.svg'
import './TrialExtensionModal.scss'
import { USER__SET_NOTIFICATIONS } from '../../../../store/actions'
import { API__USER } from '../../../../api'
import { OLD_SUB_TO_EDUCATION_FREE } from '../../../constants/ProductConstants'

const TrialExtensionModal = ({ onClose, trialCount = 0, isEducation, isTransferred = false }) => {
    const dispatch = useDispatch()
    const userNotifications = useSelector(state => state.user_notifications)

    const readEducationNotificationAndClose = async () => {
        const educationTransferNotification = userNotifications.find(obj => obj.type === OLD_SUB_TO_EDUCATION_FREE)
        if (educationTransferNotification) {
            await API__USER.SET_NOTIFICATION_READ(
                educationTransferNotification.userId,
                educationTransferNotification.id,
            )
            dispatch(USER__SET_NOTIFICATIONS(await API__USER.GET_NOTIFICATIONS(educationTransferNotification.userId)))
        }
        onClose()
    }

    return (
        <Modal
            closeOnEsc={false}
            closeOnOverlayClick={false}
            onClose={() => (isEducation ? readEducationNotificationAndClose() : onClose())}
            isShowCloseIcon
        >
            {isEducation ? (
                <div className="trial-success-modal-education">
                    <img src={womanNotebook} alt="" />
                    <p className="subscription-title">
                        <b>
                            {isTransferred
                                ? i18n.t('You are transferred to the free Education plan')
                                : i18n.t('Get started with our free Education plan')}
                        </b>
                    </p>
                    <p className="subscription-text">
                        {i18n.t('We have created special free plan for teachers, students and education programs.')}
                        &nbsp;
                        <b>
                            {isTransferred
                                ? i18n.t('You will be automatically transferred from Free to Education. Free.')
                                : i18n.t('Start creating your educational projects absolutely free.')}
                        </b>
                        &nbsp;
                        {i18n.t('If you wish, you can change your tariff plan.')}
                    </p>
                    <div className="button-container">
                        <button className="ok-button" onClick={readEducationNotificationAndClose}>
                            {i18n.t("Ok, let's get started!")}
                        </button>
                    </div>
                </div>
            ) : (
                <div className="trial-success-modal">
                    <div className="title">{i18n.t('Free trial')}</div>
                    <img src={womanWithGift} alt="" />
                    <p>
                        {trialCount > 0
                            ? i18n.t('Free period extended for 14 days')
                            : i18n.t('Free period activated for 14 days')}
                    </p>
                    <div className="button-container">
                        <button className="ok-button" onClick={onClose}>
                            {i18n.t('Ok!')}
                        </button>
                    </div>
                </div>
            )}
        </Modal>
    )
}

export default TrialExtensionModal
